import React from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Container } from "reactstrap";
// components
import withRouter from "components/Common/withRouter";
import Breadcrumbs from "components/Common/Breadcrumb";

import { DistanceDelivery } from "./components/DistanceDelivery";
import { LocalDelivery } from "./components/LocalDelivery";

const DeliveryForms = () => {
  // meta title
  document.title = "Użytkownicy - Panel administracyjny";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs breadcrumbItem="Formy dostawy" />
        <DistanceDelivery />
        <LocalDelivery />
      </Container>
    </div>
  );
};

export default withRouter(DeliveryForms);
